import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Stack } from '@mantine/core';
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { DocumentType } from '../../../../Service/DocumentT';
import { openCreateDocumentTemplateModal } from '../../../../Organismns/Document/SelectDocumentTypeAndNameModal';
import PanePaper from '../../../../Molecules/PanePaper';
import BookitupAddIcon from '../../../../Atoms/BookitupAddIcon';
import { ViolationContext } from '../../../../Service/Context/ViolationContext';
import { LicenceS } from '../../../../Service/LicenceS';
import { RoutingS } from '../../../../Service/RoutingS';
import { DocumentTemplateS } from '../../../../Service/DocumenteTemplateS';
import DocumentTemplateByDocumentType from './DocumentTemplateByDocumentType';

const DocumentTemplateList = () => {
  const { executeWithLicenceCheck } = useContext(ViolationContext);
  const navigate = useNavigate();

  useEffect(() => {
    RoutingS.changeTitle('Dokument-Vorlagen');
  }, []);

  const create = async (type: DocumentType, name: string) => {
    const resJSON = await DocumentTemplateS.create(type, name);
    if (resJSON) {
      navigate(`/settings/template/document/${type.toLowerCase()}/${name}`);
    }
  };

  return (
    <Stack>
      <PanePaper
        title="document.templates"
        tooltip="help.settings.document.templates.pane"
        rightSection={
          <BookitupAddIcon
            onClick={() =>
              executeWithLicenceCheck(LicenceS.Restrictions.MULTIPLE_DOCUMENT_TEMPLATE, () =>
                openCreateDocumentTemplateModal({ onCreate: create }),
              )
            }
          />
        }
      >
        <Stack mt="lg">
          <DocumentTemplateByDocumentType documentType="OFFER" />
          <DocumentTemplateByDocumentType documentType="CONFIRMATION" />
          <DocumentTemplateByDocumentType documentType="INVOICE" />
          <DocumentTemplateByDocumentType documentType="PARTIAL_INVOICE" />
          <DocumentTemplateByDocumentType documentType="REMINDER" />
          <DocumentTemplateByDocumentType documentType="CREDIT_NOTE" />
          <DocumentTemplateByDocumentType documentType="CANCEL" />
        </Stack>
      </PanePaper>
    </Stack>
  );
};
export default DocumentTemplateList;
